module.exports = __webpack_public_path__ + "524f84887da215617976067924444f29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/net2.png
// module id = 1063
// module chunks = 0